export const BLOG_EMAIL_LIST = [
  { label: "All Stores", value: "All_STORES" },
  { label: "Employees", value: "user" },
  { label: "FOFO Stores", value: "FOFO" },
  { label: "COCO Stores", value: "COCO" },
  { label: "BCS", value: "BCS" },
];
